import { Component, Inject, OnInit } from "@angular/core";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";

// 画像情報更新エラーダイアログ
@Component({
  selector: "app-upload-dialog",
  templateUrl: "./inspection-image-edit-error-dialog.component.html",
  styleUrls: ["./inspection-image-edit-error-dialog.component.scss"],
  standalone: false
})
export class InspectionImageEditErrorDialogComponent implements OnInit {
  successFileCount = 0;
  fileCount = 0;
  failedFileNameList: string[] = [];
  constructor(
    public dialogRef: MatDialogRef<InspectionImageEditErrorDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {}

  ngOnInit() {
    this.successFileCount = this.data.successFileCount;
    this.fileCount = this.data.fileCount;
    this.failedFileNameList = this.data.failedFileNameList;
  }
  onClick(): void {
    this.dialogRef.close();
  }
}
